import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import open_tk from './../../assets/images/ticket_l.png';
import near_sla_tk from './../../assets/images/ticket_n.png';
import missed_tk from './../../assets/images/ticket_m.png';
import resolve_tk from './../../assets/images/ticket_r.png';
import close_tk from './../../assets/images/ticket_c.png';
import $ from 'jquery';
import Header from './../../Header';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
class SlaDashboard extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = this.decrypt(localStorage.getItem('encdata'), 0);
        this.searchChange = this.searchChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.priortyChange = this.priortyChange.bind(this);
        this.ownerChange = this.ownerChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.state = {
            owners:[],
            owner:has_local_data ? localdata.user_id : '',
            priority_type:[],
            priority:'all',
            status: 'Open',
            tickets: [],
            config: '',
            message: '',
            tickets_open:'',
            tickets_nearing_sla:'',
            tickets_sla_missed:'',
            tickets_resolved:'',
            tickets_closed:'',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '', 
            searchloadmore: '',
            searchText: '',
            activePage: 1,
            item_count: '',
            loading: 1,
            isLoadMore: 1,
        };
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    back() {
        window.location.href = '/SlaDashboard';
    }
    searchChange(event) {
        var obj = this;
        this.setState({ searchText: event.target.value, activePage: 1,tickets: []});
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            localStorage.setItem('searchText', document.getElementById('searchText').value);
            obj.GetTicketList();
        }, 500);
    }
    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.GetTicketList(pageNumber);
    }
    priortyChange(event) {
        this.setState({ priority: event.target.value,activePage: 1,tickets: [],loading: 1 },function () {
            this.GetTicketList();
        });
    }
    ownerChange(event) {
        this.setState({owner: event.target.value,activePage: 1,tickets: [],loading: 1}, function () {
            this.GetTicketList();
        });
    }
    statusChange(event) {
        let stauschange = event.target.value;
        $(document).ready(function () {
            $(".dash_top").removeClass("active");
            if(stauschange==3){
                $(".dash_top.sla_d.resolve").addClass("active");
            }else if(stauschange==4){
                $(".dash_top.sla_d.close_tk").addClass("active");
            }else if(stauschange==5){
                $(".dash_top.sla_d.near").addClass("active");
            }else if(stauschange==6){
                $(".dash_top.sla_d.missed").addClass("active");
            }else{ 
                $(".dash_top.sla_d.open").addClass("active");
            }
        });
        this.setState({status: event.target.value,activePage: 1,tickets: [],loading: 1}, function () {
            this.GetTicketList();
            this.props.history.push('/SlaDashboard');
        });
    }
    studioName(studioname, ticket_master_id) {
        var studio = '';
        if (ticket_master_id != 0) {
            studio = studioname;
        } else {
            studio = 'All Stores';
        }
        return studio;
    }
    showhelpdeskid(url, id) {
        if (id != '') {
        var win = window.open(url + id, '_blank');
            win.focus()
        }
    }
    getType(type) {
        var issue_type = '';
        if (type != '') {
            issue_type = type;
            if (type == 'SetupMigration') {
                issue_type = 'Setup/Migration';
            }
        }
        return issue_type;
    }
    goToTicketDetails(ticketid) {
        this.props.history.push('/ticket/viewTicket/id/' + ticketid);
    }
    GetTicketList(page = 1) {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.list_check').addClass('hidden');
        });
        this.setState({searchText: this.state.searchText});
        localStorage.setItem('searchText', this.state.searchText);
        fetch(this.state.apiUrl + '/SlaDashboard/getTicketList/userAuthKey/' + this.state.userAuthKey + '/page/' + page, {
        method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) =>
        {
            findresponse = this.rawjsonparse(findresponse, 1);
            $(document).ready(function () {
                $('.loader-new').addClass('hidden');
                $('.list_check').removeClass('hidden');
            });
            this.setState({
                loading:0,
                isLoadMore:1,
                tickets: findresponse.tickets,
                item_count: findresponse.item_count,
                offset: findresponse.offset,
                off_count: findresponse.off_count,
                tickets_open:findresponse.tickets_open,
                tickets_nearing_sla:findresponse.tickets_nearing_sla,
                tickets_sla_missed:findresponse.tickets_sla_missed,
                tickets_resolved:findresponse.tickets_resolved,
                tickets_closed:findresponse.tickets_closed,
            })
        })
    }
    GetTicketRows(){
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div>
                    <div class="loader-new"></div>
                    <div class="list_check">
                        <div class="tickets hidden-sm">
                            <ul class="tickets_head">
                                <li class="intra_col_6 text-center">#Ticket</li>
                                <li class="intra_col_15">Customer</li>
                                <li class="intra_col_20">Title/Update</li>
                                <li class="intra_col_6">Priority</li>
                                <li class="intra_col_6">#ER</li>
                                <li class="intra_col_6">Status</li>
                                <li class="intra_col_10">Type</li>
                                <li class="intra_col_10">Owner</li>
                                <li class="intra_col_10">Age<span className="short">(Days)</span></li>
                                <li class="intra_col_11">Last Update<span className="short">(Days)</span></li>
                            </ul>
                            {
                                this.state.tickets.map((ticket, key) =>
                                    <ul class="tickets_number">
                                        <li class="intra_col_6 text-center"><Link key={key} to={`/ticket/viewTicket/id/${ticket.id}`} name={"max"} className="">
                                            {ticket.id}</Link></li>
                                        <li class="intra_col_15"><Link  to={`/ViewDetail/${ticket.studio_id}`} name={"max"} className="">
                {this.studioName(ticket.studio_name, ticket.ticket_master_id)}</Link></li>
                                        <li class="intra_col_20"><Link key={key} to={`/ticket/viewTicket/id/${ticket.id}`} name={"max"}> <div>{ticket.title} </div></Link><div class="note_ticket text-inded" dangerouslySetInnerHTML={{__html:ticket.note}} /></li>
                                        <li class="intra_col_6"> {ticket.priority}</li>
                                        <li class="intra_col_6 color-sky">
                                            <ul className="mantis">
                                                {ticket.helpdesk_id ? ticket.helpdesk_id.split(",").map(place =>
                                                <li><a onClick={() => this.showhelpdeskid('/viewEr/', place)}> {place}</a></li>) : ""
                                                }
                                            </ul>
                                        </li>
                                        <li class="intra_col_6 text-center"> {ticket.status}</li>
                                        <li class="intra_col_10">{this.getType(ticket.type)}</li>  
                                        <li class="intra_col_10">{ticket.owner}</li> 
                                        <li class="intra_col_10">{ticket.age}</li>
                                        <li class="intra_col_11">{ticket.last_updated_date}</li>                                    
                                    </ul>
                                )
                            }
                        </div>
                        <div class="tickets_mob hidden-md">
                            {
                                this.state.tickets.map((ticket, key) =>
                            <div class="list_mob">
                                <span onClick={() => this.goToTicketDetails(ticket.id)}>
                                    <h4 class="list_title"><div>{ticket.title} </div><div class="note_ticket text-inded" dangerouslySetInnerHTML={{__html:ticket.note}} /></h4>
                                    <div class="section">
                                        <div class="wrap pull-left">
                                            <label>#Ticket:</label><span>{ticket.id}</span>
                                        </div>
                                        <div class="wrap pull-right">
                                            <label>Priority</label><div class="text-capitalize">{ticket.priority}</div>
                                        </div>
                                    </div>
                                    <div class="section gry">
                                        <div class="wrap">
                                            <label>Customer</label><span>{ticket.studio_name}</span>
                                        </div>
                                        <div class="wrap pull-right">
                                            <label>{ticket.owner?'Owner:':''}</label><span>{ticket.owner}</span>
                                        </div>
                                    </div>
                                </span>
                            </div>
                                                    )
                            }
                        </div>

                        {this.state.item_count > 0 ? <div class="pagination-muvi">
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={this.state.item_count}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                            />
                            <div style={{ color: "#333" }}>
                                {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                            </div>
                        </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    </div>
                </div>
            )
        }
    }
    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 10) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }
    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/SlaDashboard/GetTicketList/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.tickets.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    tickets: this.state.tickets.concat(findresponse.tickets),
                })
            })
    }
    Getallowners(){
        fetch(this.state.apiUrl + '/SlaDashboard/GetOwners/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.rawjsonparse(findresponse, 1);
            this.setState({
                owners: findresponse.owners,
            })
        })
    }
    GetPriority() {
        fetch(this.state.apiUrl + '/SlaDashboard/GetPriority/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.rawjsonparse(findresponse, 1);
            this.setState({
                priority_type: findresponse.priority
            })
        })
    }
    export() {
        let arg = 'status/' + this.state.status + '/priority/' + this.state.priority + '/searchkeyword/' + this.state.searchText + '/owner/' + this.state.owner;
        //alert(this.state.apiUrl + "/SlaDashboard/ExportTickets/userAuthKey/" + this.state.userAuthKey + "/" + arg);
        //return false;
        var win = window.open(this.state.apiUrl + "/SlaDashboard/ExportTickets/userAuthKey/" + this.state.userAuthKey + "/" + arg, '_self');
        win.focus();
    }
    componentDidMount() {
        this.Getallowners();
        this.GetPriority();
        this.GetTicketList();
        document.title = "Intranet | Sla Dashboard";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="SLA Dashboard" brecum_page="SLA Dashboard" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            <span>SLA Dashboard</span>
                            <div class="mob-search hidden-md pull-right">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                        </div>

                        <div class="top-row">
                            <div class="left-section btn-muvi pull-left">
                                <Link to="/addticket" class="btn btn-sky mob">
                                    <span class="hidden-sm">Add Ticket</span>
                                    <span class="mob_icon_plus hidden-md">
                                    <i class="fal fa-plus"></i>
                                    </span>
                                </Link>
                                <span class="btn btn-blue hidden-sm" onClick={() => this.export()} >Export</span>
                            </div>
                            <div class="right-section">
                                <div class="row">
                                <div class="col-md-6 col-xs-12 pull-right">
                                <div class="searchTicket emp_dept">
                                    <input type="text" class="form-control" name="searchText" id="searchText" placeholder="Search ticket, customer, title" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                </div>
                                <div class="searchTicket filter dept hidden-md"><i class="fal fa-filter"></i></div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-section mob_filter">
                            <div class="form-horizontal">
                                <div class="row margin_less">
                                <div class="form-group col-sm-3 col-xs-12">
                                    <label>All Owner</label>
                                    <div class="filter">
                                        <select class="form-control" name="owners" id="owners" value={this.state.owner} onChange={this.ownerChange} >
                                            <option value='all' selected >All</option>
                                            {
                                                this.state.owners.map((dynamicData, index) =>
                                                    <option value={dynamicData.id}>{dynamicData.name}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fal fa-angle-down"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-12">
                                    <label>Status</label>
                                    <div class="filter">
                                        <select class="form-control" name="status" id="status" onChange={this.statusChange} >
                                            <option value="1" selected>Open</option>
                                            <option value="3">Resolved</option>
                                            <option value="4">Closed</option>
                                            <option value="5">Nearing SLA</option>
                                            <option value="6">SLA Missed</option>
                                        </select>
                                        <i class="fal fa-angle-down"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-12">
                                    <label>Priority</label>
                                    <div class="filter">
                                        <select class="form-control" name="priority" id="priority" onChange={this.priortyChange} >
                                            <option value='all' selected>All</option>
                                            {
                                                this.state.priority_type.map((dynamicData, index) =>
                                                    <option value={dynamicData.value}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fal fa-angle-down"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 filter_save mar_btm_16">
                                    <div class="btn-muvi todo-less">
                                        <button className="btn btn-blue" onClick={() => this.back()}>Reset</button>
                                    </div>
                                </div>
                                </div>
                                <div class="row margin_less">
                                <div class="form-group col-md-2_4 col-xs-6">
                                    <div class="dash_top sla_d open active">
                                        <div class="dash_top_image">
                                            <img src={open_tk} />
                                        </div>
                                        <h6>{this.state.tickets_open}</h6><span>Open Tickets</span>
                                    </div>
                                </div>
                                <div class="form-group col-md-2_4 col-xs-6">
                                    <div class="dash_top sla_d near">
                                        <div class="dash_top_image">
                                        <img src={near_sla_tk} />
                                        </div>
                                        <h6>{this.state.tickets_nearing_sla}</h6><span>Tickets Nearing SLA</span>
                                    </div>
                                </div>
                                <div class="form-group col-md-2_4 col-xs-6">
                                    <div class="dash_top sla_d missed">
                                        <div class="dash_top_image">
                                        <img src={missed_tk} />
                                        </div>
                                        <h6>{this.state.tickets_sla_missed}</h6><span>SLA Missed</span>
                                    </div>
                                </div>
                                <div class="form-group col-md-2_4 col-xs-6">
                                    <div class="dash_top sla_d resolve">
                                        <div class="dash_top_image">
                                        <img src={resolve_tk} />
                                        </div>
                                        <h6>{this.state.tickets_resolved}</h6><span>Resolved Tickets</span>
                                    </div>
                                </div>
                                <div class="form-group col-md-2_4 col-xs-6">
                                    <div class="dash_top sla_d close_tk">
                                        <div class="dash_top_image">
                                        <img src={close_tk} />
                                        </div>
                                        <h6>{this.state.tickets_closed}</h6><span>Closed Tickets</span>
                                    </div>
                                </div>
                                
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        {this.GetTicketRows()}
                    </div>
                </div>
            </div>
        );
    }
}
export default SlaDashboard;;


// WEBPACK FOOTER //
// ./src/components/sla/SlaDashboard.js